import { createFileRoute } from '@tanstack/react-router';
import { RoutePlaceholder } from './-components/RoutePlaceholder';

export const Route = createFileRoute('/profile/self-exclusion')({
  component: () => (
    <RoutePlaceholder
      icon="warning"
      title="Self-Exclusion"
      description="Take a break or self-exclude from gambling."
    />
  ),
});
